import React from 'react'
import PropTypes from 'prop-types'
import {
  Manager,
  Target,
  Arrow,
  Popper,
} from 'react-popper'
import './style.scss'
import { Button, Icon } from '@blueprintjs/core'
import cx from 'classnames'

function ActionMenu({active, onToggle, onActionClick, children, target}) {
  return (
    <span className="action-menu">
      <Manager className="wrapper">
        <Target>
          <Button text="Action" rightIconName="caret-down" onClick={()=>onToggle(target)}/>
        </Target>
        {active === target?(
          <Popper placement="bottom" className="popper">
            {React.Children.toArray(children).map((child, idx)=>(
              <child.type key={idx} {...child.props} onClick={(action)=>onActionClick(target, action)}/>
            ))}
            <Arrow className="popper__arrow">
              <Icon iconName="caret-up"/>
            </Arrow>
          </Popper>
        ):null}
      </Manager>
      {active?<div className={cx('screen', {active})} onClick={()=>onToggle(null)}/>:null}
    </span>
  )
}

ActionMenu.propTypes = {
  active: PropTypes.object,
  onToggle: PropTypes.func,
  onActionClick: PropTypes.func,
  children: PropTypes.node,
  target: PropTypes.object,
}

export default ActionMenu



/** WEBPACK FOOTER **
 ** ./client/components/blueprint/ActionMenu/index.js
 **/